<nz-modal
  [(nzVisible)]="isVisible"
  [nzFooter]="null"
  [nzClosable]="false"
  (nzOnCancel)="closeSuccessModal()"
  [nzCentered]="true"
  (nzOnOk)="closeSuccessModal()"
>
  <ng-container *nzModalContent>
    <div class="w-full flex flex-col space-y-4 justify-center items-center" *transloco="let t">
      <div>
        <img
          src="/icons/checkmark-circle-light.svg"
          alt="info"
          class="w-20 h-20"
        />
      </div>
      <p class="text-2xl text-mbaza-primary font-black">{{t('success')}}</p>
      <p class="text-base text-black px-3 text-center">
        {{ message }}
      </p>
    </div>
    <div class="success-footer">
      <app-mb-button
        label="OK"
        (click)="closeSuccessModal()"
        type="secondary"
        class="w-[100px]"
      />
    </div>
  </ng-container>
</nz-modal>
